const supported = new Map([
    ['ar', 'ar'],
    ['be', 'be'],
    ['bg', 'bg'],
    ['ca', 'ca'],
    ['cs', 'cs'],
    ['cy', 'cy'],
    ['da', 'da'],
    ['de', 'de'],
    ['el', 'el'],
    ['en', 'en'],
    ['es', 'es'],
    ['et', 'et'],
    ['fa', 'fa'],
    ['fi', 'fi'],
    ['fr', 'fr'],
    ['hr', 'hr'],
    ['he', 'he'],
    ['hu', 'hu'],
    ['it', 'it'],
    ['ja', 'ja'],
    ['ku', 'ku'],
    ['li', 'li'],
    ['lv', 'lv'],
    ['no', 'no'],
    ['nl', 'nl'],
    ['pl', 'pl'],
    ['pt', 'pt'],
    ['ro', 'ro'],
    ['ru', 'ru'],
    ['sk', 'sk'],
    ['sl', 'sl'],
    ['sr', 'sr'],
    ['sv', 'sv'],
    ['tr', 'tr'],
    ['uk', 'uk'],
    ['zh-Hans', 'zh-Hans'],
    ['zh-Hant', 'zh-Hant'],
]);
export function toSeatsioLanguage(locale) {
    if (!locale || typeof locale !== 'string') {
        return 'en';
    }
    const [lang, ...parts] = locale.toLowerCase().split(/[_-]/g);
    if (!lang) {
        return 'en';
    }
    if (lang === 'zh' && parts.length > 1) {
        if (parts.includes('Hans')) {
            return 'zh-Hans';
        }
        else if (parts.includes('Hant')) {
            return 'zh-Hant';
        }
    }
    return supported.get(lang) || 'en';
}
//# sourceMappingURL=language.js.map